export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    navigateToNamedRoute(namedRoute: String): void {
      this.$router.push({
        name: namedRoute,
      });
    },
  },
}
